import React from 'react';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import PropTypes from 'prop-types';
import UserAgreementToReceiveNewsletterMutation from './UserAgreementToReceiveNewsletterMutation';
import Settings from '../../../Connector/Apollo/Settings';

class UserAgreementToReceiveNewsletterConnector extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    changeAgreement = changeAgreement => async agreementValue => {
        const response = await changeAgreement({
            variables: {
                agreement: agreementValue,
            },
            update: proxy => {
                const data = proxy.readQuery({ query: Settings });

                proxy.writeQuery({
                    query: Settings,
                    data: {
                        me: {
                            ...data.me,
                            agreements: {
                                ...data.me.agreements,
                                newsletter: agreementValue,
                            },
                        },
                    },
                });
            },
            optimisticResponse: {
                me: {
                    agreementToReceiveNewsletter: {
                        code: 200,
                        __typename: 'BasicMutationSuccess',
                    },
                    __typename: 'MeMutation',
                },
            },
        });

        return response;
    };

    render() {
        const { children } = this.props;
        let result = {};

        return (
            <Mutation
                mutation={UserAgreementToReceiveNewsletterMutation}
                refetchQueries={() => [
                    {
                        query: Settings,
                    },
                ]}
            >
                {(changeAgreement, changeAgreementResult) => {
                    result = {
                        ...result,
                        changeAgreement: this.changeAgreement(changeAgreement),
                        loading: changeAgreementResult.loading,
                    };
                    return children(result);
                }}
            </Mutation>
        );
    }
}

export default UserAgreementToReceiveNewsletterConnector;
